import { GoogleMap, LoadScript, Marker } from "@react-google-maps/api"
import React, { useCallback, useEffect, useState } from "react"
import { twMerge } from "tailwind-merge"

const LocationSection = ({ bookableEventType, theme, className }) => {
  const [mapCenter, setMapCenter] = useState(null)
  const [markerPosition, setMarkerPosition] = useState(null)
  const [geocodingError, setGeocodingError] = useState(false)
  const [isLoaded, setIsLoaded] = useState(false)

  const location = bookableEventType.location

  // TODO: Getting the lat/lng in here is not ideal, it should be already saved in the backend
  const geocodeLocation = useCallback(() => {
    if (!location || !window.google || !isLoaded) return

    const geocoder = new window.google.maps.Geocoder()

    geocoder.geocode({ address: location }, (results, status) => {
      if (status === "OK" && results[0]) {
        const position = {
          lat: results[0].geometry.location.lat(),
          lng: results[0].geometry.location.lng()
        }
        setMapCenter(position)
        setMarkerPosition(position)
        setGeocodingError(false)
      } else {
        console.error("Geocoding failed:", status)
        setGeocodingError(true)
      }
    })
  }, [location, isLoaded])

  useEffect(() => {
    geocodeLocation()
  }, [geocodeLocation])

  const onLoad = useCallback(() => {
    setIsLoaded(true)
  }, [])

  const handleViewMap = () => {
    const searchQuery = encodeURIComponent(location)
    const googleMapsUrl = `https://www.google.com/maps/search/?api=1&query=${searchQuery}`
    window.open(googleMapsUrl, "_blank")
  }

  const mapContainerStyle = {
    width: "100%",
    height: "200px"
  }

  const mapOptions = {
    disableDefaultUI: true,
    zoomControl: true,
    zoom: 15
  }

  return (
    <div className={twMerge("", className)}>
      <h3 className="mb-4 text-2xl font-bold" style={{ color: theme.colorTextDark, fontFamily: theme.fontHeading }}>
        Location
      </h3>

      {/* Map Section */}
      <div className="mb-4 overflow-hidden rounded-lg border border-gray">
        <LoadScript googleMapsApiKey="AIzaSyBJzO3o3qx-4b53mVm0BA23J1z_Aj7MWmE" onLoad={onLoad}>
          {mapCenter && !geocodingError ? (
            <GoogleMap mapContainerStyle={mapContainerStyle} center={mapCenter} zoom={15} options={mapOptions}>
              {markerPosition && <Marker position={markerPosition} title={location} />}
            </GoogleMap>
          ) : geocodingError ? (
            <div className="flex h-[300px] items-center justify-center bg-gray-light">
              <p className="text-sm text-gray-dark">Unable to load map for this location</p>
            </div>
          ) : (
            <div className="flex h-[300px] items-center justify-center bg-gray-light">
              <p className="text-sm text-gray-dark">Loading map...</p>
            </div>
          )}
        </LoadScript>
      </div>

      <div className="flex items-start justify-between">
        <p className="text-base" style={{ color: theme.colorTextDark }}>
          {location}
        </p>

        <button
          onClick={handleViewMap}
          className="ml-4 whitespace-nowrap text-sm font-semibold underline transition-colors duration-150 hover:opacity-75"
          style={{ color: theme.colorAccent }}>
          View map
        </button>
      </div>
    </div>
  )
}

export default LocationSection
